import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import facepaint from "facepaint";
import { mediaQueries } from "../../tokens";

var _mediaQueries = _slicedToArray(mediaQueries, 5),
    small = _mediaQueries[0],
    medium = _mediaQueries[1],
    large = _mediaQueries[2],
    xlarge = _mediaQueries[3],
    xxlarge = _mediaQueries[4];

export var breakpoints = {
  small: small,
  medium: medium,
  large: large,
  xlarge: xlarge,
  xxlarge: xxlarge
};
export var facepaintMediaQueries = facepaint(mediaQueries);